import { type ICouponStoreService, NotInitializedError } from '../../domain/entry.js';
import { createCouponStore } from '../repositories/coupon/createCouponStore.js';

type CouponStoreInstance = ReturnType<typeof createCouponStore>;

export type ICouponZustandStoreService = ICouponStoreService<CouponStoreInstance>;

/**
 * Zustand coupon service, used to inject Zustand stor into other services to read or manipulate the store.
 *
 * @returns Zustand coupon store service
 */
export function couponStoreService(): ICouponZustandStoreService {
  // ---------- IMPORTANT! ----------
  // Keep a local copy of the store reference inside the service for now.
  // This might get problematic in the future if a dependency is within a different bundle tries to access the store,
  // then it might en up to be "undefined".
  // Then we should consider to move the reference into a provider or a more "global" (globalThis) context
  // eslint-disable-next-line @typescript-eslint/naming-convention
  let _store: ReturnType<typeof createCouponStore> | undefined;

  const bootstrap: ICouponZustandStoreService['bootstrap'] = (...args) => {
    if (_store) {
      return _store;
    }

    // For now ee keep a bootstrap function.
    // This could be replaced as a store dependency instead that handles the throw mechanism
    const store = createCouponStore(...args);

    _store = store;

    return store;
  };

  const get: ICouponZustandStoreService['get'] = () => {
    if (!_store) {
      throw new NotInitializedError();
    }

    return _store;
  };

  const set: ICouponZustandStoreService['set'] = (store: CouponStoreInstance) => {
    _store = store;
  };

  return {
    bootstrap,
    get,
    set,
  };
}
